import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const tenantCmsEntity: Entity = {
  model: model,
  repository: repository,
}

export default tenantCmsEntity
